import Vue from 'vue';
import Router from 'vue-router';
import { auth } from '@/firebase';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '',
      component: () => import('@/layouts/Main'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '/',
          redirect: '/dashboard',
        },
        // {
        //   path: '/route-planner',
        //   component: () => import('@/pages/RoutePlanner')
        // },
        {
          path: '/dashboard',
          component: () => import('@/pages/Dashboard'),
        },
        {
          path: '/purchase-orders',
          component: () => import('@/pages/PurchaseOrderManager'),
        },
        // {
        //   path: '/pallet-configurator',
        //   component: () => import('@/pages/PalletConfigurator')
        // },
        {
          path: '/products',
          component: () => import('@/pages/ProductManager'),
        },
        {
          path: '/delivery-requests',
          component: () => import('@/pages/DeliveryRequests'),
        },
        {
          path: '/delivery-request-overview/:id',
          component: () => import('@/pages/DeliveryRequestOverview'),
        },
        {
          path: '/locations',
          component: () => import('@/pages/LocationManager'),
        },
      ],
    },
    {
      path: '',
      component: () => import('@/layouts/Accounts'),
      meta: {
        requiresGuest: true,
      },
      children: [
        {
          path: '/accounts/login',
          component: () => import('@/pages/accounts/Login'),
        },
        {
          path: '/accounts/forgot-password',
          component: () => import('@/pages/accounts/ForgotPassword'),
        },
        {
          path: '/accounts/reset-password',
          component: () => import('@/pages/accounts/ResetPassword'),
        },
      ],
    },
  ],
});

// Navigation guard based on user authentication
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = !!auth.currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresGuest = to.matched.some((record) => record.meta.requiresGuest);

  if (requiresAuth && !isAuthenticated) {
    next('/accounts/login');
  } else if (requiresGuest && isAuthenticated) {
    next('/');
  } else {
    next();
  }
});

export default router;
